import * as React from 'react';
import DataTable from 'react-data-table-component';
import PublishIcon from '@material-ui/icons/Publish';
import { IconButton, TextField } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import useToken from '../../useToken';
import { useAuth } from '../../contexts/AuthContext'
import { updateData } from '../../features/harvest_report/harvestUpdateSlice';
import { useSelector, useDispatch } from 'react-redux';

const TopTenYieldTable = (rows) => {
  const [remarks, setRemarks] = React.useState({})
  const [quantity, setQuantity] = React.useState({})
  const [message, setMessage] = React.useState("Remark updated.")
  const [open, setOpen] = React.useState(false);
  const {token, setToken} = useToken()
  const dispatch = useDispatch()
  const { logout } = useAuth()
  const response = useSelector((state: any) => state.harvest_update.harvestUpdate);
  const columns = React.useMemo(()=> {
    const handleAction = event => {
      const temp = {...remarks, [event.target.id]: event.target.value}
      setRemarks(temp)
    }

    const handleQuantity = event => {
      const temp_quantity = {...quantity, [event.target.id]: event.target.value}
      setQuantity(temp_quantity)
    }

    return [
    {
      selector: 'Crop',
      name: 'Crop',
    },
    {
      selector: 'Harvest',
      name: 'Harvest on',
      sortable: true,
    },
    {
      selector: 'Greenhouses',
      name: 'Greenhouses',
      sortable: true,
    },
    {
      selector: 'Quantity',
      name: 'Quantity',
      sortable: true,
      cell: row => (
        <div key={`div-quantity-${row.Crop}_${row.Harvest}_${row.Greenhouses}`}>
          <TextField 
            fullWidth 
            key={`text-quantity-${row.Crop}_${row.Harvest}_${row.Greenhouses}`}
            id={row.HarvestId}
            style={{m: 1, width: '8ch'}} 
            defaultValue={row.Quantity}
            value={quantity[row.HarvestId]}
            margin="dense" 
            onChange= {handleQuantity}
            variant="outlined"/>
        </div>
      )
    },
    {
      selector: 'Total',
      name: 'Total Harvest (kg)',
      sortable: true,
    }, 
    {
      name: 'Remark',
      selector: 'Remark',
      grow: 3,
      cell: row => (
        <div key={`div-${row.Crop}_${row.Harvest}_${row.Greenhouses}`}>
          <TextField 
            fullWidth 
            key={`text-${row.Crop}_${row.Harvest}_${row.Greenhouses}`}
            id={row.HarvestId}
            style={{m: 1, width: '55ch'}} 
            defaultValue={row.Remark}
            value={remarks[row.HarvestId]}
            margin="dense" 
            onChange= {handleAction}
            variant="outlined"/>
        </div>
      )
    },
    {
      name: 'Update',
      right: true,
      cell: row => (
        <IconButton id={row.HarvestId} onClick={() => 
          updateRemark({
            HarvestId: row.HarvestId})}>
          <PublishIcon/>
        </IconButton>
      ),
      button: true,
      ignoreRowClick: true,
    },
  ];
  }, [remarks, quantity, setRemarks, setQuantity]);

  const updateRemark = (state) => {
    let {HarvestId} = state
    dispatch(updateData({token, HarvestId: HarvestId, Quantity: quantity[HarvestId], Remark: remarks[HarvestId]}))
    setOpen(true)
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  // if (response.error === "unauthorized") {
  //   setMessage("Login Timeout. Unable to update.")
  //   setOpen(true)
  //   logout()
  //   window.location.reload();
  // }

  const pagination = true
  const paginationPage = 25
  const paginationRowsPerPageOptions = [25]

  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataTable
        columns={columns}
        data={rows.data}
        pagination={pagination}
        paginationPerPage={paginationPage}
        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
      />
       <Snackbar
        open={open}
        autoHideDuration={1000}
        onClose={handleClose}
        message={message}
      />
    </div>
  )
}

export default TopTenYieldTable